import classNames from 'classnames'
import React from 'react'
import C from '../Const'
import {
  Bar,
  BarChart,
  CartesianGrid,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from '../recharts'
import U from '../Utils'

function ChartSaldoPerCat(props) {
  let { series, chart_data, onDrillDown, print } = props

  let colors = series.length > 1 ? [C.BLUE, C.RED] : [C.GREEN]

  return (
    <ResponsiveContainer
      aspect={C.ASPECT}
      className={classNames({
        ChartSaldoPerCat: true,
        drilldown: onDrillDown,
      })}
    >
      <BarChart layout="vertical" data={chart_data} barCategoryGap={7}>
        <CartesianGrid horizontal={false} strokeDasharray="5 5" />
        <YAxis type="category" dataKey="lbl" width={160} tickFormatter={U.formatLabel} />
        <XAxis type="number" tickFormatter={U.formatNumberPlus} />
        <ReferenceLine x={0} stroke={C.AXIS_COLOR} />
        <Tooltip formatter={U.formatNumberPlus} />
        {series.map((ser, s) => (
          <Bar
            key={s}
            dataKey={'val' + ser.suf}
            fill={colors[s]}
            name={'Saldo ' + ser.name}
            onClick={onDrillDown && ((ev) => onDrillDown(ev.id, ev.lbl))}
            isAnimationActive={!print}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  )
}

export default ChartSaldoPerCat



// WEBPACK FOOTER //
// ./src/main/ChartSaldoPerCat.js